module.exports = __webpack_public_path__ + "img/expert_advisory.5992dab1.jpg";